export default __webpack_public_path__ + "static/media/mail.554e6922.svg";